import React from "react";
import { useTranslations } from "../../../contexts";

export const AiTab: React.FC = () => {
  const i18n = useTranslations();
  return <div>{i18n["Coming soon..."]}</div>;
};
